var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Avatar',{staticClass:"header__avatar",attrs:{"size":36,"image":_vm.avatar},nativeOn:{"click":function($event){return _vm.goToAccount.apply(null, arguments)}}})}
var staticRenderFns = []

export { render, staticRenderFns }